import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiResponse } from '@shared';
import { IPaginationParams } from '../interfaces/IPaginationParamas';

@Injectable({ providedIn: 'root' })
export class SettingService {
  constructor(private http: HttpClient) {}

  getAllSettingItems(slug: string) {
    return this.http.post<ApiResponse>(`/v1/admin/settings/get/${slug}`, {});
  }

  getDropDownList(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>(`/v1/${filterData.dropDownFor}`, { params });
  }
}
